<template>
  <div>
    <!-- el-tabs 多标签页 v-event.test='`_error(a,b)`' v-event:tab-click:@test -->
    <span v-once :x='$nextTick(v=>Data.currentTab="getAuthList1")'></span>
    <el-tabs
        type="border-card"
        v-model='Data.currentTab'
        v-s.height='H-74'
        tab-click='$trigger(Data.currentTab)'
        @tab-remove="(tab)=>{
          editableTabs.splice( editableTabs.findIndex(t=>t.name === tab), 2 );
          Data.currentTab = editableTabs.length === 0 ? 'getAuthList1' : editableTabs[0].name;
        }" >

        <el-tab-pane label="目录" name='getAuthList1'>

          <el-row style="margin-bottom:10px;">
            <el-col :span="18" class='flex'>
              <el-input
                v-model="Data.inputText"
                placeholder="请输入目录名称或者接口url地址"

                clearable
                size='small'
                style="max-width:380px;" />
              <el-button
                @click='enter(Data.inputText)'
                
                type="primary"
                icon='el-icon-search'
                size='small'
                style='margin-left:10px;' >搜索</el-button>
            </el-col>
            <el-col :span="6">
              <!-- <el-button
                remark="👆上面是自定义的,👇下面是固定的无需修改"
                @click="_confirm('确定要删除所选分类吗?').trigger('deleteFirstClass',{id:queryFirstClass_data.$selection.map(v=>v.id||'').join(',')}).queryFirstClass()"
                size='small'
                type="primary"
                style="float:right"
                icon=''>删除</el-button> -->
              <el-button v-if='addAuth&&canEdit'
                @click="$form('addAuth')"
                size='small'
                type="primary"
                style="float:right;margin-right:10px;"
                icon='el-icon-circle-plus'
                >添加目录</el-button>

              <!-- <el-button
                @click="$form('addAuth')"
                size='small'
                type="primary"
                style="float:right;margin-right:10px;"
                icon='el-icon-delete' >批量删除</el-button> -->
            </el-col>
          </el-row>

          <!-- section 包裹了两个组件: el-table 表格 + el-pagination分页 它们两个通常是不可分割的整体, 一块加上 -->
          <mytable
            :tableColums='tableColums'
            x:tableData='getAuthList1_data.data'
            api='getAuthList1::authId'
            :updateapi='canEdit === false ? false : "updateAuth"'
            :height="H-230"
            xselect='muldel1 = arguments[0].length > 0'
            >
            <icol slot='authType' slot-scope='{row}' >{{ row.authType }}</icol>
            <icol slot='authParentId' slot-scope='{row}' >{{ row.authParentId }}</icol>
            <icol slot='authIcon' slot-scope='{row}' class='fCenter' >
              <i :class="row.authIcon||''" style="color:var(--Themecolor);font-size:25px;margin-right:4px;" ></i>
              <span >{{ row.authIcon }}</span>
            </icol>
          </mytable>

        </el-tab-pane>

        <el-tab-pane
          v-for="(item,index) in editableTabs"
          :key="item.name"
          :label="item.title"
          :name="item.name"
          :lazy=true :closable=true
          >

          <el-row style="margin-bottom:10px;">

            <el-col :span="18" class='flex'>
              <el-input
                v-model="item.inputText"
                placeholder="请输入菜单名称或者接口url地址"

                clearable
                size='small'
                style="max-width:380px;" />

              <el-button
                @click='enter(item.inputText)'

                type="primary"
                icon='el-icon-search'
                size='small'
                style='margin-left:10px;'
                >搜索</el-button>
              <!--@click="item.name == 'updateSecondClass' ?  queryClassByParent() : queryThirdByParent() "-->
            </el-col>

            <el-col :span="6">
              <el-button v-if='addAuth&&canEdit'
                @click="$form('addAuth')"

                size='small'
                type="primary"
                style="float:right"
                icon='el-icon-circle-plus'>
                添加{{ (void 0 === item.index ? index : item.index) === 0 ? '二级菜单' : '接口' }}
              </el-button>
            </el-col>

          </el-row>

          <mytable
            :tableColums='$this["tableColums" + ((void 0 === item.index ? index : item.index)+2)]'
            :api='`getAuthList${ (void 0 === item.index ? index : item.index) + 2 }::authId`'
            :updateapi='canEdit === false ? false : "updateAuth"'
            :height="H-230"
            >
            <icol slot='authIcon' slot-scope='{row}' class='fCenter' >
              <i :class="row.authIcon||''" style="color:var(--Themecolor);font-size:25px;margin-right:4px;" ></i>
              <span >{{ row.authIcon }}</span>
            </icol>
          </mytable>

        </el-tab-pane>

      </el-tabs>

      <myform
        :viewobj='{
          addAuth:    [ "新增接口", "el-icon-circle-plus" ],
          updateAuth: [ "修改角色信息", "el-icon-edit-outline"],
          $succeed$: ()=>$this[Data.currentTab]()
        }'
        @opened="arguments[0].title = oPlus[Data.currentTab] + $this['$'+Data.currentTab].authName, Myformdata.with({
          authParentId: $this['$'+Data.currentTab].authId,
          authType: Data.currentTab.slice(-1) * 1 - 1,
          authOrder: ($this[Data.currentTab + '_data'].data||'').length + 1
        })"
        @close='arguments[1] && $form("addAuth","reset")' 
        >
        <!-- <hide slot='id'/> -->
        <template v-slot:authParams='{Myformdata}' >
          <el-input
            v-model="Myformdata.authParams" type="textarea" style='width:100%;'
            :autosize='{minRows:1}'
            placeholder='可在此输入接口参数(如果有多个参数,请换行填写)'
           />
        </template>
      </myform>
      <myform
        :viewobj='{
          updateAuthParent: [ "修改父级权限", "el-icon-edit-outline"],
          $succeed$: ()=>$this[Data.currentTab]()
        }'
        @close='arguments[1] && $form("updateAuthParent","reset")' 
        >
        <hide slot='authId'/>
      
      </myform>
      <!-- El-Dialog对话框 + El-Form表单 公用组件 | 在需要弹框进行交互的情况下, 它们两个也是不可分割的整体 ! -->

      <!-- <myform
        :viewobj="{
          addFirstClass  : [ '新增一级分类', 'el-icon-circle-plus' ],
          updateFirstClass : [ '修改一级分类', 'el-icon-edit-outline'],

          addSecondClass: [ '新增二级分类', 'el-icon-circle-plus' ],
          updateSecondClass: [ '修改二级分类', 'el-icon-edit-outline' ],

          addThirdClass: [ '新增三级分类', 'el-icon-circle-plus' ],
          updateThirdClass: [ '修改三级分类', 'el-icon-edit-outline' ],

          $button$ : [ '取消', '确定' ],

          $succeed$: $Case( Data.currentTab, {
            updateFirstClass: 'queryFirstClass',
            updateSecondClass: 'queryClassByParent',
            $else$: 'queryThirdByParent'
          })
        }"
        @close='$form(Data.currentTab,"reset")'
        >
        <hide slot='id' />
        <hide slot='level' />
        <hide slot='parent' />
      </myform> -->


    </div>
</template>

<script>
//import func from '../../../vue-temp/vue-editor-bridge';
/*
  样例说明：
  1）所有接口支持链式调用，如 addUser('正在添加..').queryUser("正在查询..")
*/
export default {
  data() {
    return {
      canEdit: null, //是否可编辑
      muldel1: false,
      muldel2: false,
      muldel3: false,
      oPlus: {
        'getAuthList1': '新增目录',
        'getAuthList2': '新增菜单 | @',
        'getAuthList3': '新增功能 | @',
      },
      editableTabs: [
        /* {
          title: '二级分类',
          name: 'updateSecondClass',
          // content: 'Tab 1 content'
        },
        {
          title: '三级分类',
          name: 'updateThirdClass',
          // content: 'Tab 2 content'
        },
            _confirm('确定要删除该分类吗?')
              .then(id=>{
                 $this[ Data.currentTab.replace('update','delete') ]({id:$row.id})
                .trigger($refs.MyForm.viewobj.$succeed$)
                .trigger(tab=>{
                   tab = Data.currentTab;
                   editableTabs.splice( ( tab = editableTabs.findIndex(v=>v.name===tab), tab === -1 ? 0 : tab + 1 ), 2 );
                })

              })
        */
      ],

      /* 在这里 动态渲染你的 tableColums表格列, 哪一列不需要, [!注释掉 或 删除掉!] 即可 ; 还可以在这里 [!增改!] 列 */
      tableColums: {
        $selection: false,

        // authId : [ "主键id", 70 ],

        // authType : [ "类型", 70 ],

        // authParentId : [ "父级id", 70 ],

        authName : ["目录名称",110], 

        authIcon: ['目录图标'],

        authUrl : ["Vue页面"],

        authOrder : [ "排序", 80 ],
        
        // authOperationType : [ "操作类型", 80 ],

        createtime: [ "创建时间", 200 ],

        $operation: ( this.updateAuth || this.deleteAuth ) && [
          "操作", 250,

          this.updateAuth && `@text: 编辑#success
           @v-if: canEdit
           @click: $form( 'updateAuth', $row )
          `,

          this.deleteAuth && `@text: 删除#danger
           @v-if: canEdit
           @click: _confirm('确定要删除该目录吗?')
                  .trigger( 'deleteAuth', {authId:$row.authId} )
                  .trigger( Data.currentTab )
          `,

          `@text: {{ ( P = ($row.authUrl||'A')[0].charCodeAt(0) ) !== 35 && P !== 8367 ? '查看二级菜单' : '查看子功能' }}#warn
           @click:
              let find, index, name = 'getAuthList' + ( index = ( index = ($row.authUrl||'A')[0] !== '#' ) && index !== '₯' ? 2 : 3 ); 
              
              editableTabs.length === 0 || void null === ( find = editableTabs.find(v=>v.name === name) )
              ? editableTabs.push({ name: Data.currentTab = name, title: $row.authName, index: index - 2 })
              : find.title = $row.authName;

              $this['$'+name] = $row;
              $this[name]({authType: index-1, authParentId: $row.authId})(v=>Data.currentTab=name);
          `

        ]
      },

      tableColums2: {
        $selection: false,

        // authId : [ "主键id", 70 ],

        // authType : [ "类型", 70 ],

        // authParentId : [ "父级id", 70 ],

        authName : [ "菜单名称", 110 ],

        authUrl : ["Vue页面"],

        authIcon: ['菜单图标'],

        authOrder : [ "排序", 80 ],
        
        authOperationType : [ "操作类型", 120, '@v-if: 0:查询 🔍#(--Themecolor), 1:新增 ➕#success, 2:编辑 🖊#warn, 3:删除 ❌#danger+' ],

        createtime: [ "创建时间", 200 ],

        $operation: ( this.updateAuth || this.deleteAuth ) && [
          "操作", 250,

          this.updateAuth && `@text: 编辑#success
           @v-if: canEdit
           @click: $form( 'updateAuth', $row )
          `,
          this.updateAuthParent && `@text: 修改父级#success
           @click: $form( 'updateAuthParent', $row )
          `,

          this.deleteAuth && `@text: 删除#danger
           @v-if: canEdit
           @click: _confirm('确定要删除该菜单吗?')
                  .trigger( 'deleteAuth', {authId:$row.authId} )
                  .trigger( Data.currentTab )
          `,

          // @v-if: Data.currentTab !== 'updateThirdClass'
          `@text: 查看所有功能#warn
           @click:
              let find, name = 'getAuthList3'; $this['$'+name] = $row;
              editableTabs.length === 0 || void null === ( find = editableTabs.find(v=>v.name === name) )
              ? editableTabs.push({ name: Data.currentTab = name, title: $row.authName })
              : find.title = $row.authName;
              getAuthList3({authType:2,authParentId:$row.authId})(v=>Data.currentTab=name);
          `

        ],

      },

      tableColums3: {
        $selection: false,

        // authId : [ "主键id", 70 ],

        // authType : [ "类型", 70 ],

        // authParentId : [ "父级id", 70 ],

        authName : [ "接口描述", 125 ],

        authRemark: [ '接口调用', 160 ],

        authUrl : ["接口地址|align:left"],

        authParams: ['接口参数|align:left',300],

        authOrder : [ "排序", 80 ],

        authOperationType : [ "操作类型", 120, '@v-if: 0:查询 🔍#(--Themecolor), 1:新增 ➕#success, 2:编辑 🖊#warn, 3:删除 ❌#danger+' ],

        createtime: [ "创建时间", 100 ],

        $operation: ( this.updateAuth || this.deleteAuth || this.addAuth ) && [
          "操作", 150,

          this.updateAuth && `@text: 编辑#success
           @v-if: canEdit
           @click: $form( 'updateAuth', $row )
          `,

          this.deleteAuth && `@text: 删除#danger
           @v-if: canEdit
           @click: _confirm('确定要删除该接口吗?')
                  .trigger( 'deleteAuth', {authId:$row.authId} )
                  .trigger( Data.currentTab )
          `,

          this.addAuth && `@text: 复制接口#success
           @v-if: canEdit
           @click: $form('addAuth',$row)
          `
        ],

      },

      /*queryFirstClass_data: {
        data: [ ],
        msg: '查询成功!',
        code: 1,
      },*/

    };
  },

  watch: {
    // "queryFirstClass_data.data": function(data){
    //   // data.forEach()
    //   // console.error(data,this);
    // },

    // 'Data.currentTab': function(tab){
    //   console.error(tab,111111111);
    // }
  },

  methods: {
    enter(input='') {
      var s;
      const Data = this[this.Data.currentTab + '_data'];
      Data[ /[A-z]/.test(input[0]) ? ( s = "authName", "authUrl" ) : ( s = "authUrl", "authName" ) ] = input, Data[s] = '';
      this[this.Data.currentTab]({ authName: Data.authName, authUrl: Data.authUrl });
    },
    getCanEditAuth:async function(){
      const res = await  this.$post( $Api.getSysKeyCanEditAuth, null, '' );
      if( res && res.isuccess ) {
        this.canEdit=res.data.data;
      }
      console.log("canEdit",this.canEdit)
    }

  },

  created() {
    /* 在这里调用初始化接口 或者 执行你自己的数据存储和逻辑 */
    this.$getAuthList1 = { authType: 0, authId: 0, authParentId: 0, authName: '' };
    this.getAuthList1({authType: 0, authParentId: 0});
    this.getCanEditAuth();
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/AuthList/#AuthList.vue